export default {
  redeemCode: {
    title: 'Canjear Código',
    description: 'Introduce tu código de canje a continuación para reclamar tu recompensa.',
    enterTip: 'Ingresa tu código de canje para reclamar recompensas',
    label: 'Código de Canje',
    placeholder: 'Introduce el código de canje',
    submit: 'Canjear',
    redeemBtn: 'CANJEAR',
    submitting: 'Canjeando...',
    success: '¡Código canjeado con éxito!',
    redeemSuccess: '¡Código canjeado con éxito!',
    failed: 'No se pudo canjear el código, inténtalo de nuevo.',
    redeemFailed: 'No se pudo canjear el código, inténtalo de nuevo.'
  }
};
